import React, { useRef, useEffect, useState } from 'react';
import HumanModelLogic from './script'; // Adjust the path if necessary
import Treatments from '../../assets/json/treatments.json'; // Adjust the JSON import path if necessary
import Lottie from 'react-lottie';
import animationData from '../../assets/json/drag-and-drop.json'; // Replace 'your-animation.json' with the path to your Lottie animation JSON file
import ContactModal from '../ContactModal';
import { motion } from 'framer-motion';

function HumanBody({prenota}) {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [shoulderPress, setShoulderPress] = useState('Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, sequi? Facere voluptatum iure enim! Ut maiores itaque molestiae eligendi explicabo accusantium hic dolores esse. Sunt tenetur esse aut blanditiis hic.');
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedTreatments, setSelectedTreatments] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [contactModal, setContactModal] = useState(false);
  const [markerPosition, setMarkerPosition] = useState(null);

  const openContactModal = () => {
    setContactModal(true);
  };

  const closeContactModal = () => {
    setContactModal(false);
  };

  const defaultOptionsDAD = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const handleSelectedSection = (section) => {
    setShoulderPress(`${section}`);
    setSelectedSection(section);
  };

  const handleHovered = (section) => {
    if(section){
      // setIsHovered(true);
    }
  };

  useEffect(() => {
    HumanModelLogic({ handleSelectedSection, handleHovered, setMarkerPosition, containerRef, contentRef });
    return () => {};
  }, []);

  useEffect(() => {
    if (selectedSection) {
      let treatmentsFound = false;

      // Loop through each section in Treatments to find the matching ID
      Treatments.forEach((section) => {
        if (section.id === selectedSection) {
          setSelectedTreatments(section.conditions);          
          setBackgroundImage(section.image); 
          setSelectedRegion(section.region);
          
          treatmentsFound = true;
        }
      });

      if (!treatmentsFound) {
        setSelectedTreatments([]);
        setBackgroundImage('');
      }
    }
  }, [selectedSection]);


  return (
    <div className="flex">
      <div className="w-full h-full relative overflow-hidden flex" ref={containerRef}>

        {/* Canvas Section */}
        <div className="relative pt-32 w-1/2 self-start">
          <canvas ref={canvasRef} className="webgl !w-full" id='canvasModel' />
        
          {markerPosition && (
            <svg className="absolute top-0 left-0 w-full h-full pointer-events-none z-50" key={`${markerPosition.x}-${markerPosition.y}`}>
              <motion.circle
                cx={markerPosition.x}
                cy={markerPosition.y}
                r="3"
                fill="#65806E"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.2 }}
              />
              <motion.path
                d={`
                  M ${markerPosition.x} ${markerPosition.y}
                  L ${(markerPosition.x + markerPosition.tx) / 2} ${markerPosition.y}
                  L ${markerPosition.tx} ${markerPosition.ty}
                `}
                stroke="#65806E"
                strokeWidth="2"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{
                  duration: 0.7,
                  ease: "easeInOut"
                }}
              />
              <motion.circle
                cx={markerPosition.tx}
                cy={markerPosition.ty}
                r="3"
                fill="#65806E"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                  delay: 0.6,
                  duration: 0.2
                }}
              />
            </svg>
          )}
        </div>

        {/** Content Section */}
        <div className={`w-1/2 bg-mcare`}>
          <div className="h-full w-full glassmorphism-trattamenti">
            <div className="text-left text-white flex flex-col justify-center space-y-6 w-full h-full p-14" ref={contentRef}>
              
              <h1 className="text-4xl font-bold text-[#65806E] mt-30 mb-5 uppercase panoragraf-light">
                {selectedRegion === '' ? 'Interagisci con il Modello 3D' : selectedRegion}
              </h1>

              {selectedRegion === '' ? ( 
                <div className="max-w-3xl">
                  <p className="text-lg mb-8 tracking-wider">
                    Clicca su una delle aree del corpo sul modello 3D a sinistra per scoprire tutti i trattamenti disponibili per quella zona. 
                    Esplora le opzioni e scegli il trattamento più adatto alle tue esigenze!
                  </p>
                  {!isHovered && 
                    <div className='z-40'>
                      <Lottie
                        options={defaultOptionsDAD}
                        height={250}
                        width={250}
                      />
                    </div>
                  }
                </div>
              ) : (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  key={selectedRegion}
                >
                  <h2 className="text-2xl font-semibold mb-5">Trattamenti</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 grid-cols-auto gap-y-4 gap-x-10">
                    {selectedTreatments.map((condition, index) => (
                      <div key={index} className="mb-4">
                        <h3 className="font-semibold mb-5 text-xl tracking-wider">{condition.name}:</h3>
                        <ul className="list-disc pl-5 text-lg tracking-wider">
                          {condition.treatments.map((treatment, idx) => (
                            <li key={idx}>{treatment}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  <button className="w-fit px-8 py-2 mt-5 progress-button-mcare text-lg tracking-wider" onClick={prenota}>
                    Prenota una consulenza
                  </button>
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </div>
       
    </div>
  );
}

export default HumanBody;
